{
  "translation": {
    "aboutMirador": "About Project Mirador",
    "aboutThisItem": "About this item",
    "addedFromUrl": "(Added from URL)",
    "addManifestUrl": "Resource location",
    "addManifestUrlHelp": "The URL of a IIIF resource",
    "addResource": "Add resource",
    "annotationCanvasLabel_1/1": "Item: [{{label}}]",
    "annotationCanvasLabel_1/2": "Left: [{{label}}]",
    "annotationCanvasLabel_2/2": "Right: [{{label}}]",
    "annotations": "Annotations",
    "attribution": "Attribution",
    "attributionTitle": "Rights",
    "authenticationFailed": "Authentication failed.",
    "authenticationRequired": "Authentication required for full access",
    "backToResults": "Back to results",
    "book": "Book",
    "bottom": "Bottom",
    "cancel": "Cancel",
    "canvasIndex": "Index",
    "changeTheme": "Change theme",
    "clearSearch": "clear",
    "clearSearchAria": "Reset search",
    "close": "Close",
    "closeAddResourceForm": "Close form",
    "closeAddResourceMenu": "Close resource list",
    "closeCompanionWindow": "Close panel",
    "closeWindow": "Close window",
    "collapseSection": "Collapse \"{{section}}\" section",
    "collapseSidePanel": "Collapse sidebar",
    "collection": "Collection",
    "continue": "Continue",
    "copy": "Copy",
    "currentItem": "Current item",
    "currentItem_1/1": "Current item",
    "currentItem_1/2": "Left",
    "currentItem_2/2": "Right",
    "dark": "Dark theme",
    "digitizedView": "Digitized view",
    "dismiss": "Dismiss",
    "displayNoAnnotations": "Highlight none",
    "downloadExport": "Export workspace",
    "downloadExportWorkspace": "Export workspace",
    "elastic": "Elastic",
    "elasticDescription": "Move and size windows freely in an unlimited workspace. Windows can overlap.",
    "emptyResourceList": "Your resource list is empty",
    "error": "Error",
    "errorDialogConfirm": "OK",
    "errorDialogTitle": "An error occurred",
    "exitFullScreen": "Exit full screen",
    "expandSection": "Expand \"{{section}}\" section",
    "expandSidePanel": "Expand sidebar",
    "exportCopied": "The workspace configuration was copied to your clipboard",
    "fetchManifest": "Add",
    "fullScreen": "Full Screen",
    "gallery": "Gallery",
    "hideWindowSideBar": "Hide sidebar",
    "hideZoomControls": "Hide zoom controls",
    "highlightAllAnnotations": "Highlight all",
    "iiif_homepage": "About this resource",
    "iiif_manifest": "IIIF manifest",
    "iiif_related": "Related",
    "iiif_renderings": "Alternate formats",
    "iiif_seeAlso": "See also",
    "imageFailedToLoad": "Problem loading image. See console for details.",
    "import": "Import",
    "importWorkspace": "Import workspace",
    "importWorkspaceHint": "Paste a Mirador 4 configuration to be imported",
    "item": "Item: {{label}}",
    "itemList": "Item list",
    "jsError": "Technical details",
    "jsStack": "{{ stack }}",
    "language": "Language",
    "layer_hide": "Hide layer",
    "layer_move": "Move layer",
    "layer_moveToBackground": "Move layer to background",
    "layer_moveToFront": "Move layer to front",
    "layer_opacity": "Layer opacity",
    "layer_show": "Show layer",
    "layers": "Layers",
    "light": "Light theme",
    "links": "Links",
    "listAllOpenWindows": "Jump to window",
    "login": "Log in",
    "logout": "Log out",
    "manifestError": "The resource cannot be added:",
    "maximizeWindow": "Maximize window",
    "minimizeWindow": "Minimize window",
    "mirador": "Mirador",
    "miradorResources": "Mirador resources",
    "miradorViewer": "Mirador viewer",
    "more": "more...",
    "moreResults": "More results",
    "mosaic": "Mosaic",
    "mosaicDescription": "Move and size windows in relation to each other, within the visible frame.",
    "moveCompanionWindowToBottom": "Move to bottom",
    "moveCompanionWindowToRight": "Move to right",
    "multipartCollection": "Multipart Collection",
    "nextCanvas": "Next item",
    "noItemSelected": "No item selected",
    "numItems_one": "{{number}} item",
    "numItems_other": "{{number}} items",
    "off": "Off",
    "openCompanionWindow_annotations": "Annotations",
    "openCompanionWindow_attribution": "Rights",
    "openCompanionWindow_canvas": "Index",
    "openCompanionWindow_info": "Information",
    "openCompanionWindow_layers": "Layers",
    "openCompanionWindow_search": "Search",
    "openInCompanionWindow": "Open in separate panel",
    "openWindows": "Current open windows",
    "pagination": "{{current}} of {{total}}",
    "position": "Position",
    "previewWindowTitle": "{{title}}",
    "previousCanvas": "Previous item",
    "related": "Related",
    "resource": "Resource",
    "retry": "Retry",
    "right": "Right",
    "rights": "License",
    "scroll": "Scroll",
    "searchInputLabel": "search terms",
    "searchNextResult": "Next result",
    "searchNoResults": "No results found",
    "searchPreviousResult": "Previous result",
    "searchResultsRemaining": "{{numLeft}} remaining",
    "searchSubmitAria": "Search in the document",
    "searchTitle": "Search",
    "selectWorkspaceMenu": "Select workspace type",
    "showCollection": "Show collection",
    "showingNumAnnotations_one": "Showing {{number}} annotation",
    "showingNumAnnotations_other": "Showing {{number}} annotations",
    "showWindowSideBar": "Show sidebar",
    "showZoomControls": "Show zoom controls",
    "sidebarPanelsNavigation": "Sidebar panels navigation",
    "single": "Single",
    "startHere": "Start Here",
    "suggestSearch": "Search this document for \"{{ query }}\"",
    "tableOfContentsList": "Table of contents",
    "theme": "Theme",
    "thumbnailList": "Thumbnail list",
    "thumbnailNavigation": "Thumbnails",
    "thumbnails": "Thumbnails",
    "toggleWindowSideBar": "Toggle sidebar",
    "totalCollections_one": "{{count}} collection",
    "totalCollections_other": "{{count}} collections",
    "totalManifests_one": "{{count}} manifest",
    "totalManifests_other": "{{count}} manifests",
    "tryAgain": "Try again",
    "untitled": "[Untitled]",
    "view": "View",
    "viewWorkspaceConfiguration": "View workspace configuration",
    "welcome": "Welcome to Mirador",
    "window": "Window: {{label}}",
    "windowMenu": "Window views & thumbnail display",
    "windowNavigation": "Window navigation",
    "windowPluginButtons": "Options",
    "windowPluginMenu": "Window options",
    "workspace": "Workspace",
    "workspaceFullScreen": "Full screen",
    "workspaceMenu": "Workspace settings",
    "workspaceNavigation": "Workspace navigation",
    "workspaceOptions": "Workspace options",
    "workspaceSelectionTitle": "Select a workspace type",
    "zoomIn": "Zoom in",
    "zoomOut": "Zoom out",
    "zoomReset": "Reset zoom"
  }
}
